<template>
  <div class="search-results-display-container">
    <div class="search-item" v-for="stock in stocks" :key="`${stock.xc}-${stock.code}-${stock.sgm}`"
      @click="$emit('select', stock)">
      <div class="search-item-content">
        <div class="search-item-code-row">
          <strong>{{ stock.code }}</strong>
          <span v-if="getStockIsin(stock)" class="search-item-isin">{{ getStockIsin(stock) }}</span>
        </div>
        <div class="search-item-name">{{ stock.nEN }}</div>
        <div class="search-item-meta">{{ getStockMeta(stock) }}</div>
      </div>
      <div class="search-item-arrow">&rsaquo;</div>
    </div>
    <div v-if="0 === groups.length">
      {{ noMatchingLabel }}
    </div>
  </div>
</template>

<script>
export default {
  emits: ["select"],
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    groups: {
      type: Array,
      required: true,
    },
    noMatchingLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    stocks() {
      return this.groups.flatMap(group => group.stocks);
    },
  },
  methods: {
    getStockIsin(stock) {
      return stock?.isin || stock?.ISIN || stock?.isinCode || stock?.is || stock?.i || "";
    },
    getStockMeta(stock) {
      const exchangeAndSegment = [stock?.xc, stock?.sgm]
        .filter(value => value)
        .join(" | ");
      return [exchangeAndSegment, stock?.cc, stock?.categoryLabel]
        .filter(value => value)
        .join(" . ");
    },
  },
};
</script>

<style scoped>
.search-results-display-container {
  flex: 1;
  overflow: auto;
}

.search-item {
  color: #6d6d6d;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.search-item:last-of-type {
  margin-bottom: 0;
}

.search-item-content {
  min-width: 0;
}

.search-item-code-row,
.search-item-name,
.search-item-meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-item-code-row {
  color: #222;
  font-size: 1rem;
}

.search-item-code-row strong {
  color: #222;
  margin-right: 0.35rem;
}

.search-item-isin {
  font-weight: 400;
}

.search-item-name,
.search-item-meta {
  font-size: 0.9rem;
}

.search-item-arrow {
  color: #111;
  flex: 0 0 auto;
  font-size: 2rem;
  line-height: 1;
}
</style>
